import React, { PureComponent } from "react";
import { PieChart, Pie,  ResponsiveContainer } from "recharts";

const data = [{ name: "Group C", value: 200 }, { name: "Group D", value: 200 }];

export default class PieChatSimple extends PureComponent {
  render() {
    return (
      <div style={{ height: "150px" }} className="rotate">
        <ResponsiveContainer>
          <PieChart className="pieChartSimple3">
            <Pie
              isAnimationActive={false}
              data={data}
              labelLine={false}
              fill="#0eb89a"
              dataKey="value"
            />
          </PieChart>
        </ResponsiveContainer>
        {this.props.data.peer1Name ? (
          <ResponsiveContainer>
            <PieChart className="pieChartSimple2">
              <Pie
                isAnimationActive={false}
                data={data}
                labelLine={false}
                fill="#bffc33"
                dataKey="value"
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div />
        )}

        {this.props.data.peer2Name ? (
          <ResponsiveContainer>
            <PieChart className="pieChartSimple1">
              <Pie
                isAnimationActive={false}
                data={data}
                labelLine={false}
                fill="#f9a528"
                dataKey="value"
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div />
        )}

        {this.props.data.peer3Name ? (
          <ResponsiveContainer>
            <PieChart className="pieChartSimple0">
              <Pie
                isAnimationActive={false}
                data={data}
                labelLine={false}
                fill="#8961cc"
                dataKey="value"
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Charts/PieChart/PieChartSimple.js